export default "__VITE_ASSET__DO2HTmXh__"